module.exports = __webpack_public_path__ + "media/green_checkmark.3ae5a727.webm";